import React from "react";

const QuickLinks: React.FC = () => {
  return null; // Component removed - links consolidated to main CTA
};

export default QuickLinks;